import type { Template } from "@/types";

export const PO_06_H0_V6: Template[] = [
    {
        id: "po-06-h0v6-01",
        name: "PO 01 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_01.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 108, y: 179, width: 293, height: 461, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 408, y: 179, width: 139, height: 227, rotation: 0, imageRotation: 0 },
            { id: "3", x: 408, y: 414, width: 139, height: 226, rotation: 0, imageRotation: 0 },
            { id: "4", x: 701, y: 126, width: 370, height: 570, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1079, y: 126, width: 188, height: 281, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1079, y: 415, width: 188, height: 281, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-02",
        name: "PO 02 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_02.png",
        size: [1311, 820],
        style: {},
        slots: [         
            { id: "1", x: 68, y: 164, width: 164, height: 241, rotation: 0, imageRotation: 0 },
            { id: "2", x: 68, y: 413, width: 164, height: 241, rotation: 0, imageRotation: 0 },
            { id: "3", x: 240, y: 164, width: 349, height: 490, rotation: 0, imageRotation: 0 },
            { id: "4", x: 723, y: 164, width: 349, height: 490, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1080, y: 164, width: 164, height: 241, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1080, y: 413, width: 164, height: 241, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-03",
        name: "PO 03 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_03.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 51, y: 126, width: 371, height: 570, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 429, y: 126, width: 176, height: 281, rotation: 0, imageRotation: 0 },
            { id: "3", x: 429, y: 415, width: 176, height: 281, rotation: 0, imageRotation: 0 },
            { id: "4", x: 757, y: 182, width: 292, height: 457, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1057, y: 182, width: 154, height: 225, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1057, y: 415, width: 154, height: 224, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-04",
        name: "PO 04 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_04.png",
        size: [1311, 820],
        style: {},
        slots: [          
            { id: "1", x: 55, y: 215, width: 269, height: 391, rotation: 0, imageRotation: 0 },
            { id: "2", x: 332, y: 215, width: 269, height: 391, rotation: 0, imageRotation: 0 },
            { id: "3", x: 710, y: 126, width: 403, height: 570, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1121, y: 126, width: 135, height: 185, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1121, y: 319, width: 135, height: 185, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1121, y: 512, width: 135, height: 184, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-05",
        name: "PO 05 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_05.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 51, y: 205, width: 128, height: 183, rotation: 0, imageRotation: 0 },
            { id: "2", x: 51, y: 395, width: 128, height: 183, rotation: 0, imageRotation: 0 },
            { id: "3", x: 186, y: 205, width: 254, height: 373, rotation: 0, imageRotation: 0 },
            { id: "4", x: 447, y: 205, width: 128, height: 183, rotation: 0, imageRotation: 0 },
            { id: "5", x: 447, y: 395, width: 128, height: 183, rotation: 0, imageRotation: 0 },
            { id: "6", x: 626, y: 0, width: 626, height: 783, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-06",
        name: "PO 06 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_06.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 198, y: 126, width: 403, height: 570, rotation: 0, imageRotation: 0 },
            { id: "2", x: 710, y: 215, width: 271, height: 391, rotation: 0, imageRotation: 0 },
            { id: "3", x: 989, y: 215, width: 270, height: 391, rotation: 0, imageRotation: 0 },
            { id: "4", x: 55, y: 126, width: 135, height: 185, rotation: 0, imageRotation: 0 },
            { id: "5", x: 55, y: 319, width: 135, height: 185, rotation: 0, imageRotation: 0 },
            { id: "6", x: 55, y: 512, width: 135, height: 184, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-07",
        name: "PO 07 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_07.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 656, height: 820, rotation: 0, imageRotation: 0 },
            { id: "2", x: 705, y: 215, width: 270, height: 391, rotation: 0, imageRotation: 0 },
            { id: "3", x: 983, y: 215, width: 136, height: 192, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1127, y: 215, width: 136, height: 192, rotation: 0, imageRotation: 0 },
            { id: "5", x: 983, y: 415, width: 136, height: 191, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1127, y: 415, width: 136, height: 191, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-08",
        name: "PO 08 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_08.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 0, y: 131, width: 451, height: 558, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 459, y: 131, width: 193, height: 275, rotation: 0, imageRotation: 0 },
            { id: "3", x: 459, y: 414, width: 193, height: 275, rotation: 0, imageRotation: 0 },
            { id: "4", x: 660, y: 131, width: 193, height: 275, rotation: 0, imageRotation: 0 },
            { id: "5", x: 660, y: 414, width: 193, height: 275, rotation: 0, imageRotation: 0 },
            { id: "6", x: 861, y: 131, width: 450, height: 558, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-09",
        name: "PO 09 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_09.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 0, y: 259, width: 212, height: 305, rotation: 0, imageRotation: 0 },
            { id: "2", x: 220, y: 259, width: 212, height: 305, rotation: 0, imageRotation: 0 },
            { id: "3", x: 440, y: 259, width: 212, height: 305, rotation: 0, imageRotation: 0 },
            { id: "4", x: 660, y: 259, width: 212, height: 305, rotation: 0, imageRotation: 0 },
            { id: "5", x: 880, y: 259, width: 212, height: 305, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1100, y: 259, width: 211, height: 305, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-10",
        name: "PO 10 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_10.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 46, y: 268, width: 197, height: 283, rotation: 0, imageRotation: 0 },
            { id: "2", x: 251, y: 268, width: 197, height: 283, rotation: 0, imageRotation: 0 },
            { id: "3", x: 456, y: 268, width: 197, height: 283, rotation: 0, imageRotation: 0 },
            { id: "4", x: 661, y: 268, width: 197, height: 283, rotation: 0, imageRotation: 0 },
            { id: "5", x: 866, y: 268, width: 196, height: 283, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1070, y: 268, width: 196, height: 283, rotation: 0, imageRotation: 0 }
        ],
    }
];